export default __webpack_public_path__ + "static/media/section6-img2.69f38ca4.png";